import { render, staticRenderFns } from "./Tuliao.vue?vue&type=template&id=682f33ea&scoped=true"
import script from "./Tuliao.vue?vue&type=script&lang=js"
export * from "./Tuliao.vue?vue&type=script&lang=js"
import style0 from "./Tuliao.vue?vue&type=style&index=0&id=682f33ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682f33ea",
  null
  
)

export default component.exports